import React, { ButtonHTMLAttributes } from "react";
import styled from "styled-components";
import Tooltip, { TooltipPosition } from "../Tooltip/Tooltip";

const Button = styled.button`
  background-color: transparent;
  opacity: ${(props): string => (props.disabled ? "0.5" : "1")};
  cursor: ${(props): string => (props.disabled ? "not-allowed" : "pointer")};
  color: ${(props): string => props.theme.colors.yellow};
  border: none;
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
  display: flex;
  transition: background-color 0.3s;
`;

export const TableActionButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: row;
`;

interface TableActionButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  disabled?: boolean;
  iconSrc?: string;
  alt: string;
  $tooltipContent?: string;
  $tooltipPosition?: TooltipPosition;
}

const TableActionButton = ({
  $tooltipContent,
  $tooltipPosition,
  onClick,
  disabled,
  iconSrc,
  alt,
  ...props
}: TableActionButtonProps): React.JSX.Element => {
  return (
    <Tooltip content={$tooltipContent} position={$tooltipPosition}>
      <Button
        className={!disabled ? "hover-scale" : ""}
        {...props}
        onClick={onClick}
        disabled={disabled}
      >
        <img
          src={iconSrc}
          alt={alt}
          style={{
            alignSelf: "center",
            objectFit: "contain",
            userSelect: "none",
          }}
        />
      </Button>
    </Tooltip>
  );
};

export default TableActionButton;
